class BookskipController {
  constructor($scope, jqService, $timeout, $http, $state, $cookies) {
    this.request = $scope.request || {};
    this.actions = $scope.actions || {};

    this.jqService = jqService;
    this.$timeout = $timeout;
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;

    this.actions.stepone = this.stepone.bind(this);

    this.dateOptions = {
      dateDisabled: this.disabled,
      formatYear: 'yyyy',
      maxDate: new Date(new Date().getTime() + 40 * 24 * 60 * 60 * 1000),
      minDate: new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000),
      startingDay: 1,
      showWeeks: false
    };

    this.endDateOptions = {
      dateDisabled: this.disabled,
      formatYear: 'yyyy',
      maxDate: new Date(new Date().getTime() + 40 * 24 * 60 * 60 * 1000),
      minDate: new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000),
      startingDay: 1,
      showWeeks: false
    };

    this.popupStart = {
      opened: false
    };

    this.popupEnd = {
      opened: false
    };
  }

  getLocation(val) {
    // http://rentaskip.com.au/Ajax.aspx/GetLocations?locality=syd
    // return this.$http.get('//maps.googleAPIs.com/maps/API/geocode/json', {
    return this.$http
      .get('/Ajax.aspx/GetLocations', {
        params: {
          locality: val
        }
      })
      .then(function(response) {
        return response.data.records;
      });
  }

  onSelect = function($item, $model, $label) {
    this.request.Locality = $item;
  };

  stepone(form) {
    if (form.$valid) {
      if (
        this.request.pickupdate &&
        this.request.returndate &&
        this.request.Locality
      ) {
        // console.log(this.request);
        this.$cookies.put('request', JSON.stringify(this.request));

        // navigate
        this.$state.go('app.steptwo', {
          request: this.request
        });
      }
    }
  }

  setStartDate() {
    this.endDateOptions.minDate = new Date(
      this.request.pickupdate.getTime()
    ).setDate(this.request.pickupdate.getDate() + 1);
    this.request.returndate = null;
  }

  disabled(data) {
    var date = data.date,
      mode = data.mode;
    //return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    return mode === 'day' && date.getDay() === 0;
  }
}

BookskipController.$inject = [
  '$scope',
  'jqService',
  '$timeout',
  '$http',
  '$state',
  '$cookies'
];

export { BookskipController };



/** WEBPACK FOOTER **
 ** ./src/app/components/bookskip/bookskip.controller.js
 **/